<template>
  <el-dialog :title="form.id?'编辑':'新增'" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="120px" style="margin-right:10px">
      <el-form-item label="添加语言" prop="titleArr" v-if="!form.id">
        <div v-for="(item,index) in form.titleArr" :key="index" class="ipt-box">
          <el-input v-model="item.title" placeholder="请输入" maxlength="1000" show-word-limit />
          <i class="el-icon-plus" @click="handleAddItem"></i>
          <i class="el-icon-minus" @click="handleDeleteItem(index)"></i>
        </div>
      </el-form-item>
      <el-form-item label="添加语言" prop="title" v-else>
        <el-input v-model="form.title" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="状态" prop="isEnable" v-if="!isMessage">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch> {{form.isEnable?'启用':'禁用'}}
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import custServiceSpeechcraftApi from '@/api/customer/custServiceSpeechcraft'
function initFormBean() {
  const formBean = {
    titleArr: [{ title: '' }],
    isEnable: false,
  }
  return formBean
}

export default {
  props: ['isMessage'],
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        titleArr: [{ required: true, message: '请输入关键字', trigger: 'blur' }],
        title: [{ required: true, message: '请输入关键字', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isRepSub: false
    }
  },
  created() {

  },
  methods: {
    resetForm() {
      this.form = initFormBean()
    },
    handleCreate() {
      this.resetForm()
      if (this.isMessage) this.form.isEnable = true
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }

      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    calcParams() {
      let { titleArr, isEnable } = this.form;
      let arr = []
      titleArr.forEach(it => {
        if (it.title) arr.push({ title: it.title, isEnable })
      })
      return arr
    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            if (this.isMessage) this.form.isEnable = true
            let Ins = +this.isMessage ? custServiceSpeechcraftApi.updateMe : custServiceSpeechcraftApi.update
            Ins(this.form).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            let Ins = +this.isMessage ? custServiceSpeechcraftApi.createMe : custServiceSpeechcraftApi.create
            let params = this.calcParams()
            Ins(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(data) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
    handleDeleteItem(index) {
      this.form.titleArr.splice(index, 1)
    },
    handleAddItem() {
      this.form.titleArr.push({ title: '' })
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.ipt-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding-right: 20px;
  i {
    font-size: 16px;
    cursor: pointer;
  }
}
.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
